var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SunwayDatePicker',{attrs:{"size":"small","options":Object.assign({}, _vm.options, {type: 'RangePicker'})},on:{"change":_vm.changeHandle},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }